import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'

const FormEditSensors = () => {
    const [temperature, setTemperature] = useState("")
    const [humidity, setHumidity] = useState("")
    const [msg, setMsg] = useState("")
    const navigate = useNavigate();
    const { id } = useParams();

    axios.defaults.withCredentials = true;

    useEffect(() => {
        const getSensorById = async () => {
            try {
                const response = await axios.get(`https://ayres-iot-backend.cyclic.app/sensors/${id}`)
                setTemperature(response.data.temperature)
                setHumidity(response.data.humidity)
            } catch (error) {
                if (error.response) {
                    setMsg(error.response.data.msg);
                }
            }
        }
        getSensorById();
    }, [id])

    const updateSensor = async (e) => {
        e.preventDefault();
        try {
            await axios.patch(`https://ayres-iot-backend.cyclic.app/sensors/${id}`, {
                temperature: temperature,
                humidity: humidity
            })
            navigate("/sensors")
        } catch (error) {
            if (error.response) {
                setMsg(error.response.data.msg);
            }
        }
    }


    return (
        <div><h1 className='title'>Sensors</h1>
            <h2 className='subtitle'>Edit Data</h2>

            <div className="column is-4 is-offset-4">
                <div className="content box">
                    <form onSubmit={updateSensor}>
                        {msg && <div className="notification is-danger is-light">
                            {msg}
                        </div>}
                        <div className="field">
                            <label className="label">Temperature</label>
                            <div className="control">
                                <input type="number" className="input" value={temperature} onChange={(e) => setTemperature(e.target.value)} placeholder='Temperature' />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Humidity</label>
                            <div className="control">
                                <input type="number" className="input" value={humidity} onChange={(e) => setHumidity(e.target.value)} placeholder='Humidity' />
                            </div>
                        </div>
                        <div className="field">
                            <div className='control'></div>
                            <button type='submit' className="button is-success">Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}

export default FormEditSensors